// extracted by mini-css-extract-plugin
module.exports = {"link":"_22YPo","SloopyButton":"_290LR","sloopyButton":"_290LR","label":"_2R_a9","brd":"_1NfUk","top":"_9VP_J","bot":"_3J-2d"};